module.exports = __webpack_public_path__ + "static/media/1014885.66206c17.jpg";